'use strict';
const angular = require('angular');
import SettingsController from './settings.controller';

export default angular.module('nomasvelloDashboardApp.settings', [])
  .controller('SettingsController', SettingsController)
  .name;



// WEBPACK FOOTER //
// ./client/app/account/settings/index.ts